import { styled } from '@mui/material/styles';
import { Paper, Box, Button, TextField } from '@mui/material';

export const FormContainer = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(4),
    margin: theme.spacing(2),
    maxWidth: 800,
    marginLeft: 'auto',
    marginRight: 'auto',
}));

export const FormTitle = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(3),
    textAlign: 'center',
}));

export const FormSection = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));

export const SectionTitle = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
    fontSize: '1.1rem',
    color: theme.palette.primary.main,
}));

export const FormRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
}));

export const FormField = styled(TextField)(({ theme }) => ({
    flex: 1,
    minWidth: 200,
}));

export const FullWidthField = styled(TextField)(({ theme }) => ({
    width: '100%',
    marginBottom: theme.spacing(2),
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
    minWidth: 120,
    padding: theme.spacing(1.5),
}));

export const ResetButton = styled(Button)(({ theme }) => ({
    minWidth: 120,
    padding: theme.spacing(1.5),
}));
